import { useState } from 'react';

export default function usePopoverState({
  onClose = () => {},
  onEnter = () => {},
}) {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const openPopover = (event) => {
    setAnchorEl(event.currentTarget);
  };


  const handleClose = () => {
    setAnchorEl(null);
    onClose();
  };

  const handleEnter = () => {
    onEnter();
  };

  return {
    handleClose,
    handleEnter,
    openPopover,
    anchorEl,
    open,
  };
}
